
export default function Guide() {

    return (
        <img src="../iconslimsvet/guides.png" alt="Guides"/>
    );
}